// import React from 'react';
import ReactDOM from 'react-dom';
import commonUtil from './commonUtil';
// import DownloadPDFWithoutPreview from './../components/DownloadPDFWithoutPreview';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageNameTableOrg = 'tableOrganizer';

const PDFUtil = {
  containerDom: null,
  componentToRemove: null,
  attachToDom(pdfContent, fileName, callback, orientation, pageName, mode) {
    commonUtil.showApplicationLoader();
    this.containerDom = document.querySelector('#downloadContainer');
    // const downloadData = (<DownloadPDFWithoutPreview printingDate={printingDate} downloadContent={pdfContent} />);
    const onCompletion = callback || this.contentDownloadedCallback;
    if (!this.containerDom) {
      const _div = '<div id="downloadContainer" style=position:absolute;z-index:-9;top:0;left:0;opacity:0.01 />';
      document.querySelector('body').insertAdjacentHTML('beforeend', _div);
      this.containerDom = document.querySelector('#downloadContainer');
    }
    this.componentToRemove = ReactDOM.render(pdfContent, this.containerDom, () => {
      if (pageNameTableOrg === pageName && mode === 'grid') {
        window.scrollTo(0, 0);
        setTimeout(() => {
          const canvasEl = document.querySelector('#downloadContainer .floor .dropArea');
          commonUtil.generateImageCanvas(canvasEl, () => { commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName); });
        }, 1500);
      }
    });
    if (pageNameTableOrg === pageName) {
      if (mode !== 'grid') {
        window.scrollTo(0, 0);
        commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName);
      }
    } else {
      commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion);
    }
  },
  attachToDomForiOS(pdfContent, fileName, callback, orientation, pageName, mode) {
    commonUtil.showApplicationLoader();
    this.containerDom = document.querySelector('#downloadContainer');
    // const downloadData = (<DownloadPDFWithoutPreview printingDate={printingDate} downloadContent={pdfContent} />);
    const onCompletion = (data) => {
      this.contentDownloadedCallback();
      callback(data);
    };
    // const onCompletion = data => data;
    if (!this.containerDom) {
      const _div = '<div id="downloadContainer" style=position:absolute;z-index:-9;top:0;left:0;opacity:0.01 />';
      document.querySelector('body').insertAdjacentHTML('beforeend', _div);
      this.containerDom = document.querySelector('#downloadContainer');
    }
    this.componentToRemove = ReactDOM.render(pdfContent, this.containerDom, () => {
      if (pageNameTableOrg === pageName && mode === 'grid') {
        window.scrollTo(0, 0);
        setTimeout(() => {
          const canvasEl = document.querySelector('#downloadContainer .floor .dropArea');
          commonUtil.generateImageCanvas(canvasEl, () => { commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName); });
        }, 1500);
      }
    });
    if (pageNameTableOrg === pageName) {
      if (mode !== 'grid') {
        window.scrollTo(0, 0);
        commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName, true);
      }
    } else {
      commonUtil.downloadPdfWithoutPreview('.printPage', `${fileName}.pdf`, onCompletion, undefined, undefined, true);
    }
  },

  contentDownloadedCallback() {
    /* eslint-disable */
    ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(document.querySelector('#downloadContainer')));
    /* eslint-enable */
    commonUtil.hideApplicationLoader();
  },

  attachToDomForPrint(print, pageName) {
    // commonUtil.showApplicationLoader();
    this.containerDom = document.querySelector('#downloadContainer');
    if (!this.containerDom) {
      const _div = '<div id="downloadContainer" style=position:absolute;z-index:-9;top:0;left:0;opacity:0.01 />';
      document.querySelector('body').insertAdjacentHTML('beforeend', _div);
      this.containerDom = document.querySelector('#downloadContainer');
    }

    ReactDOM.render(print, this.containerDom);
    if (pageNameTableOrg === pageName) {
      window.open(commonUtil.routeTo(applicationRoutes.printData, [{ pageName }], 'PRINT', '_blank', 'height=auto,width=auto'));
    } else {
      window.open(commonUtil.routeTo(applicationRoutes.printData, [{ pageName }], 'PRINT', '_blank', 'height=400,width=600'));
    }
  },
  attachToDomForMail(pdfContent, fileName, callback, orientation, pageName, mode) {
    commonUtil.showApplicationLoader();
    this.containerDom = document.querySelector('#downloadContainer');
    // const downloadData = (<DownloadPDFWithoutPreview printingDate={printingDate} downloadContent={pdfContent} />);
    const onCompletion = callback || this.contentDownloadedCallback;
    if (this.containerDom) {
      this.componentToRemove = ReactDOM.render(pdfContent, this.containerDom, () => {
        if (pageNameTableOrg === pageName && mode === 'grid') {
          window.scrollTo(0, 0);
          setTimeout(() => {
            const canvasEl = document.querySelector('#downloadContainer .floor .dropArea');
            commonUtil.generateImageCanvas(canvasEl, () => { commonUtil.mailPdf('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName); });
          }, 1500);
        }
      });
      if (pageNameTableOrg === pageName) {
        if (mode !== 'grid') {
          window.scrollTo(0, 0);
          commonUtil.mailPdf('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName);
        }
      } else {
        commonUtil.mailPdf('.printPage', `${fileName}.pdf`, onCompletion);
      }
    } else {
      const _div = '<div id="downloadContainer" style=position:absolute;z-index:-9;top:0;left:0;opacity:0.01 />';
      document.querySelector('body').insertAdjacentHTML('beforeend', _div);
      this.containerDom = document.querySelector('#downloadContainer');
      this.componentToRemove = ReactDOM.render(pdfContent, this.containerDom);
      if (pageNameTableOrg === pageName) {
        commonUtil.mailPdf('.printPage', `${fileName}.pdf`, onCompletion, orientation, pageName);
      } else {
        commonUtil.mailPdf('.printPage', `${fileName}.pdf`, onCompletion);
      }
    }
  },
  contentPrintedCallback() {
    if (window && window.opener) {
      /* eslint-disable */
      ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(window.opener.document.querySelector('#downloadContainer')));
      /* eslint-enable */
      // commonUtil.hideApplicationLoader();
      if (window.opener.document !== undefined) {
        if (window.opener.document.getElementById('loading')) {
          window.opener.document.getElementById('loading').style.display = 'none';
        }
      }
    }
  },
};

export default PDFUtil;
